import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { TdDialogService } from '@covalent/core';
import { AuthenticationService } from '../../../../shared/services/authentication.service';

@Component({
  selector: 'app-pda-shipping-main',
  templateUrl: './pda-shipping-main.component.html',
  styleUrls: ['./pda-shipping-main.component.scss']
})
export class PdaShippingMainComponent implements OnInit {

  constructor(private _dialogService: TdDialogService,
    private location: Location,
    public _authService: AuthenticationService
  ) { }

  ngOnInit() {
  }

  goBack(): void {
    this.location.back();
  }
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/pda/shipping/main/pda-shipping-main.component.ts